<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',

}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
  .c-header
  {
    background-color: #80a057;
  }
  .c-header-nav-link
  {
    color: #fff !important;
  }
  .c-subheader
  {
    display: none;
  }
  .c-sidebar-brand > svg
  {
    display: none !important;
  }
.c-sidebar {
    color: #fff;
    background: #80a057;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

/* Global classes */
.disabled > input,
.disabled > .dropdown
{
  pointer-events: none;
  opacity: 0.7;
}
.vue-tags-input
{
  max-width: unset !important;
  border-radius: 6px;
}
.vue-tags-input.is-invalid
{
  border: 1px solid #e55353;
}
.gap-1
{
  gap: 1rem;
}

.quillWrapper.is-invalid .ql-snow.ql-toolbar,
.quillWrapper.is-invalid .ql-snow.ql-container
{
    border-color: #e55353;
}
</style>
